import type { RouteRecordRaw } from 'vue-router';
import { adminAuthStore } from '@/stores/adminAuthStore';

const basePath = '/inspirio-inc-admin';

const adminRoutes: RouteRecordRaw[] = [
  {
    path: basePath,
    name: 'admin-root',
    component: () => import('@/views/admin/AdminLayout.vue'),
    meta: {
      type: 'admin',
      isHeader: false,
      isLeft: false,
    },
    redirect: () => {
      const store = adminAuthStore();
      return store.login ? `${basePath}/dashboard` : `${basePath}/login`;
    },
    children: [
      {
        path: 'login',
        name: 'admin-login',
        component: () => import('@/views/admin/AdminLogin.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
        },
      },
      {
        path: 'emails',
        redirect: `${basePath}/emails/compose`,
      },
      {
        path: 'emails/compose',
        name: 'admin-emails-compose',
        component: () => import('@/views/admin/emails/EmailsCompose.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'emails/recipients',
        name: 'admin-emails-recipients',
        component: () => import('@/views/admin/emails/EmailsRecipients.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'emails/history',
        name: 'admin-emails-history',
        component: () => import('@/views/admin/emails/EmailsHistory.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: () => import('@/views/admin/AdminDashboard.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'admins',
        name: 'admin-admins',
        component: () => import('@/views/admin/AdminsList.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'admins/new',
        name: 'admin-admins-new',
        component: () => import('@/views/admin/AdminForm.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'admins/:adminIdx/edit',
        name: 'admin-admins-edit',
        component: () => import('@/views/admin/AdminForm.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'coupons/catalog',
        name: 'admin-coupons-catalog',
        component: () => import('@/views/admin/coupons/CouponsCatalog.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'coupons/members',
        name: 'admin-coupons-members',
        component: () => import('@/views/admin/coupons/MemberCoupons.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'coupons/issue',
        name: 'admin-coupons-issue',
        component: () => import('@/views/admin/coupons/CouponIssue.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'ai-tokens/policy',
        name: 'admin-ai-tokens-policy',
        component: () => import('@/views/admin/AiTokensPolicy.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
      {
        path: 'ai-tokens/billing',
        name: 'admin-ai-tokens-billing',
        component: () => import('@/views/admin/AiTokensBilling.vue'),
        meta: {
          type: 'admin',
          isHeader: false,
          isLeft: false,
          isAdmin: true,
        },
        beforeEnter: (_to, _from, next) => {
          const store = adminAuthStore();
          if (store.login && store.key) return next();
          return next(`${basePath}/login`);
        },
      },
    ],
  },
];

export default adminRoutes;


